import { useSelector } from "react-redux";
import store from "../storeWire";
import {
  setFilterList,
  clearFilterByKey,
  clearAllFilter,
  clearArryVal
} from "../store/slice/model/ObjCommonFilter";

export function useObjCommonFilterStore () {
  const filter_list = useSelector((state) => state.entities.model_Obj_common_filter.filterList)

  const data = {
    filter_list
  };
  const fetch = {
  };
  const set = {
    set_filter_list: async (params) => {
      return await store.dispatch(setFilterList(params))
    },
    clear_filter_by_key: async (params) => {
      return await store.dispatch(clearFilterByKey(params))
    },
    clear_all_filter: async () => {
      return await store.dispatch(clearAllFilter())
    },
    clear_array_value: async (params) => {
      return await store.dispatch(clearArryVal(params))
    }
  };

  return [ data, fetch, set ]
}